import { useState } from "react";
import { Text } from "@fluentui/react-components";
import { SparkleRegular } from "@fluentui/react-icons";
import { WorkspaceDocuments } from "apps/project-iq/components/WorkspaceDocuments/WorkspaceDocuments";
import { useWorkspaceFilesStyles } from "./WorkspaceFiles.styles";
import { IWorkspaceFilesProps } from "./WorkspaceFiles.types";

export type { IWorkspaceFilesProps };

export const WorkspaceFiles = ({
  workspaceId,
  clientName,
  sharepointConnections,
  onSaveStatusChange,
}: IWorkspaceFilesProps): JSX.Element => {
  const styles = useWorkspaceFilesStyles();
  const [isDocumentsLoading, setIsDocumentsLoading] = useState(true);

  return (
    <div className={styles.contextFilesLayout}>
      <div className={styles.contextFilesContent}>
        <WorkspaceDocuments
          workspaceId={workspaceId}
          clientName={clientName}
          sharepointConnections={sharepointConnections}
          onSaveStatusChange={onSaveStatusChange}
          onLoadingChange={setIsDocumentsLoading}
        />
        {!isDocumentsLoading && (
          <div className={styles.sharedLayerBanner}>
            <SparkleRegular
              className={styles.sharedLayerBannerIcon}
              aria-hidden="true"
            />
            <Text className={styles.sharedLayerBannerText}>
              All team members have access to all files stored in this workspace
              for the engagement. All files are available as context throughout
              Project IQ.
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};
